



























import { defineComponent } from "@vue/composition-api";
import { isCallMessageDetails } from "@scrile/api-provider/dist/api/CallsProvider";
import { MessageThread } from "@scrile/api-provider/dist/api/MessageThreadsProvider";
import { isTipMessageDetails } from "@scrile/api-provider/dist/api/TipProvider";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import { timeAgo } from "@/lib/time";
import BaseAvatar from "@/components/BaseAvatar";
import BaseIcon from "@/components/BaseIcon";
import BasePage from "@/components/BasePage";
import MessagePreview from "@/components/MessagePreview";
import PageTitle from "@/components/PageTitle";
import ScreenNamePrinter from "@/components/ScreenNamePrinter";

export default defineComponent({
  name: "MessageThreadItem",
  components: { ScreenNamePrinter, MessagePreview, BasePage, BaseIcon, PageTitle, BaseAvatar },
  props: {
    messageThread: { type: Object as () => MessageThread, required: true },
    authUserId: { type: String, required: true },
    isBlocked: { type: Boolean, default: false },
  },
  computed: {
    to(): { name: string; params: { userId: string } } {
      const userId = this.messageThread.userIds.find(i => i !== this.authUserId) || this.authUserId;
      return { name: "messages", params: { userId } };
    },
    user(): UserPublicData | undefined {
      return (
        this.messageThread?.users.find(i => i.id !== this.authUserId) ??
        this.messageThread?.users.find(i => i.id === this.authUserId)
      );
    },
    timeData(): string {
      return timeAgo(this.messageThread.updatedTime);
    },
    isOpponentMessage(): boolean {
      if (!this.messageThread.lastMessage) return false;
      else if (isCallMessageDetails(this.messageThread.lastMessage.details)) {
        return this.messageThread.lastMessage.details.callerId !== Number(this.authUserId);
      } else if (isTipMessageDetails(this.messageThread.lastMessage.details)) {
        return Number(this.messageThread.lastMessage.details.senderId) !== Number(this.authUserId);
      } else {
        return this.messageThread.lastMessage.senderId !== this.authUserId;
      }
    },
    markAsSeen(): boolean {
      return (
        !!this.messageThread.lastMessage &&
        (this.messageThread.opponentMinUnreadMessageId === "0" ||
          this.messageThread.lastMessage.id < this.messageThread.opponentMinUnreadMessageId)
      );
    },
  },
});
